<div mat-dialog-content>

    <div class="flex flex-col flex-auto min-w-0">
        <div class="bg-card">
            <div class="flex flex-col min-w-0 ml-4">
                <ng-container *transloco="let t">
                </ng-container>
            </div>
            <br>
            <mat-card-content>
                <h5>Datos generales</h5>
                <form [formGroup]="formBankAccount" class="row d-flex justify-content-start align-items-center">
                    <div class="col-sm-12 col-md-12 col-xl-12 ">
                        <mat-label>Titular: <span class="mandatory">*</span></mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <input matInput placeholder="Titular" formControlName="titular" maxlength="200">
                            <mat-error *ngIf="formBankAccount.get('titular').hasError ('required')"><strong>*Este
                                    campo es obligatorio</strong></mat-error>
                        </mat-form-field>
                    </div>
    
                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Clabe: <span class="mandatory">*</span></mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <input matInput placeholder="Clabe" formControlName="clabe" maxlength="18" (input)="textSearchBanco('idBanco', $event)">
                            <mat-error *ngIf="formBankAccount.get('clabe').hasError ('required')"><strong>*Este campo es
                                    obligatorio</strong></mat-error>
                            <mat-error *ngIf="formBankAccount.get('clabe').hasError ('pattern')"><strong>*Solo aceptan valores numéricos, con logitud de 18 caracteres</strong></mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Número de cuenta: <span class="mandatory">*</span></mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <input matInput placeholder="Número de cuenta" formControlName="noCuenta" maxlength="50">
                            <mat-error *ngIf="formBankAccount.get('noCuenta').hasError ('required')"><strong>*Este campo es
                                    obligatorio</strong></mat-error>
                            <mat-error *ngIf="formBankAccount.get('noCuenta').hasError ('pattern')"><strong>*Solo aceptan valores numéricos</strong></mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Banco: <span class="mandatory">*</span></mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <mat-select name="tipo" placeholder="Seleccione" formControlName="idBanco">
                                <mat-option *ngFor="let banco of lstBancos" [value]="banco.id">
                                    {{ banco.attributes.clave }} - {{ banco.attributes.nombre }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formBankAccount.get('clabe').hasError ('required')"><strong>*Este campo es
                                    obligatorio</strong></mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Sucursal: </mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <input matInput placeholder="Sucursal" maxlength="50" formControlName="sucursal">
                        </mat-form-field>
                    </div>

                </form>

            </mat-card-content>

        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close(0)">Cerrar</button>
    <button *ngIf="!modificarDatos" mat-flat-button color="accent" [disabled]="!formBankAccount.valid" cdkFocusInitial (click)="addBankAccount();">Guardar</button>
    <button *ngIf="modificarDatos" mat-flat-button color="accent" cdkFocusInitial (click)="modifyBankAccount();">Actualizar</button>
</div>